/** To avoid cyclic dependencies, import getState and dispatch from here instead of Store.js */

import type { AnyAction, Store } from 'redux';
import type { RootState } from './reducers';

type AppStore = Store<RootState, AnyAction>;

let _store: AppStore | null = null;

export function setStore(store: AppStore): void {
  _store = store;
}

export function getState(): RootState {
  if (!_store) {
    throw new Error(
      'Redux store not set. Call setStore(store) during app bootstrap.'
    );
  }
  return _store.getState();
}

export function dispatch(action: unknown): unknown {
  if (!_store) {
    throw new Error(
      'Redux store not set. Call setStore(store) during app bootstrap.'
    );
  }
  return _store.dispatch(action as AnyAction);
}
